import { render, staticRenderFns } from "./AppTable.vue?vue&type=template&id=f52994b8&scoped=true&"
import script from "./AppTable.vue?vue&type=script&lang=js&"
export * from "./AppTable.vue?vue&type=script&lang=js&"
import style0 from "./AppTable.vue?vue&type=style&index=0&id=f52994b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52994b8",
  null
  
)

export default component.exports